export default __webpack_public_path__ + "static/media/logo.b50b8142.svg";